export default __webpack_public_path__ + "static/media/eyepatch.5cf9a6a8.png";